<template>
    <div>


        <!-- normal form -->
        <div v-if="!showRich">
            <v-tabs
                v-model="tab"
                centered
                grow
                active-class="font-weight-bold tab-active"
                slider-size="2"
            >

                <v-tab href="#1" :class="`tab-header  ${stClasses.st1}`">
                    Generales
                </v-tab>

                <v-tab href="#2" :class="`tab-header  ${stClasses.st2}`">
                    Contenido
                </v-tab>

            </v-tabs>

            <!-- STEP 1 "generales" -->
            <v-tabs-items v-model="tab">
                <v-tab-item value="1">

                    <div class="mt-3">
                        <v-row>
                            <v-col class="py-2">
                                <textFieldForm
                                    name="p1"
                                    label="Nombre del curso"
                                    :valueInput="values.title"
                                    :rule="rules.required"
                                    @valueChange="
                                        (v) => {
                                            values.title = v.trim();
                                            delete serverErrors.title;
                                        }
                                    "
                                    :errorMessages="serverErrors.title"
                                ></textFieldForm>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                            <fileInputForm
                                label="Imágen del curso"
                                :multiple="false"
                                :valueInput="values.image_file"
                                :url="values.image_url"
                                :rule="rules.fileRequired"
                                @valueChange="(v) => {values.image_file = v; delete serverErrors.image_file}"
                                :errorMessages="serverErrors.image_file"
                                v-on:update:url="values.image_url = $event"
                                ></fileInputForm>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="py-2">
                                <textAreaForm 
                                    @valueChange="(v) => {values.brief_description = v.trim(); delete serverErrors['brief_description']}" 
                                    :valueInput="values.brief_description" 
                                    :rule="rules.required" 
                                    label="Descripción breve"
                                    :errorMessages="serverErrors['brief_description']"
                                    class="brief_description-input"
                                    :rows="2"
                                ></textAreaForm>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="py-2">
                                <textFieldForm
                                    name="p1"
                                    label="Duración en horas"
                                    :valueInput="values.duration"
                                    :rule="rules.required"
                                    @valueChange="
                                        (v) => {
                                            values.duration = v.trim();
                                            delete serverErrors.duration;
                                        }
                                    "
                                    :errorMessages="serverErrors.duration"
                                ></textFieldForm>
                            </v-col>
                        </v-row>


                        <v-row>
                            <v-col class="py-2">
                                <textAreaForm 
                                    @valueChange="(v) => {values.summary = v.trim(); delete serverErrors['summary']}" 
                                    :valueInput="values.summary" 
                                    :rule="rules.required" 
                                    label="Resumen del curso"
                                    :errorMessages="serverErrors['summary']"
                                    class="summary-input"
                                    :rows="2"
                                ></textAreaForm>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="py-2">
                                <textAreaForm 
                                    @valueChange="(v) => {values.what_you_will_learn = v.trim(); delete serverErrors['what_you_will_learn']}" 
                                    :valueInput="values.what_you_will_learn" 
                                    :rule="rules.required" 
                                    label="¿Qué aprenderá el estudiante?"
                                    :errorMessages="serverErrors['what_you_will_learn']"
                                    class="what_you_will_learn-input"
                                    :rows="2"
                                ></textAreaForm>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                <autocompleteMultipleForm
                                    label="Empresas de interés"
                                    :primaryColorMode="true"
                                    :valueInput="values.list_companies"
                                    :loading="loadingCompanies"
                                    :rule="rules.listRequired"
                                    :items="serverItems.companies"
                                    @valueChange="(v) => {values.list_companies = v; delete serverErrors.list_companies}"
                                    :errorMessages="serverErrors.list_companies"
                                    :returnObject="true"
                                ></autocompleteMultipleForm>
                            </v-col>
                        </v-row>

                        
                    </div>


                </v-tab-item>

            </v-tabs-items>



            <!-- STEP 2 "Contenido" -->
            <v-tabs-items v-model="tab">
                <v-tab-item value="2">
                    <div class="mt-3">

                        <v-row>
                            <v-col>
                                <div class="courses-form-new-section-container">
                                    <p class="pr-2">
                                        AGREGA TANTAS SECCIONES COMO SEAN NECESARIAS PARA EL CURSO, DENTRO DE CADA SECCIÓN PODRÁS AGREGAR LECCIONES PARA DESARROLLAR
                                    </p>
                                    <iconButton
                                        class=""
                                        :props="{
                                            hasTooltip:true,
                                            tooltip: 'Agregar sección',
                                            color:'primary',
                                            icon:'mdi-plus',
                                            height:'35',
                                            click: () => {addSection()}
                                        }"
                                    ></iconButton>
                                </div>
                            </v-col>
                        </v-row>


                        <v-row v-for="(section, indexS) in values.sections" :key="indexS">
                            <v-col>
                                <v-card class="my-1 mx-1">
                                    <v-card-text>
                                        <v-row>
                                            <v-col>
                                                <textFieldForm
                                                    name="p1"
                                                    label="Nombre de la sección"
                                                    :valueInput="section.title"
                                                    :rule="rules.required"
                                                    @valueChange="
                                                        (v) => {
                                                            section.title = v.trim();
                                                            delete serverErrors[`sections.${indexS}.title`];
                                                            delete serverErrors[`sections.${indexS}`];
                                                        }
                                                    "
                                                    :errorMessages="serverErrors.title"
                                                ></textFieldForm>
                                            </v-col>
                                            <v-col>
                                                <div class="courses-form-lesson-btns-container">
                                                    <iconButton
                                                        :props="{
                                                            hasTooltip:true,
                                                            tooltip: 'Borrar sección',
                                                            color:'',
                                                            icon:'mdi-delete-outline',
                                                            height:'35',
                                                            iconColor: 'black',
                                                            outline: true,
                                                            click: () => {deleteSection(indexS)}
                                                        }"
                                                    ></iconButton>
                                                    <secondary-button 
                                                        :props="{...addLessonBtnData, 
                                                            click: () => {
                                                                addLesson(section, indexS);
                                                                delete serverErrors[`sections.${indexS}.lessons`];
                                                                delete serverErrors[`sections.${indexS}`];
                                                            }}" 
                                                            class="ml-3"
                                                        ></secondary-button>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons`] }}</p>
                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.title`] }}</p>
                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}`] }}</p>


                                        <!-- lessos -->
                                        
                                        <v-row v-for="(lesson, indexL) in section.lessons" :key="indexL">
                                            <v-col>
                                                <v-card>
                                                    <v-card-text>
                                                        <v-row>
                                                            <v-col>
                                                                <div class="courses-form-lesson-btns-container">
                                                                    <textFieldForm
                                                                        name="p1"
                                                                        label="Título de la lección"
                                                                        :valueInput="lesson.title"
                                                                        :rule="rules.required"
                                                                        @valueChange="
                                                                            (v) => {
                                                                                lesson.title = v.trim();
                                                                                delete serverErrors[`sections.${indexS}.lessons.${indexL}.title`]
                                                                            }
                                                                        "
                                                                        :errorMessages="serverErrors.title"
                                                                    ></textFieldForm>
                                                                    <v-icon :color="lesson.has_content || lesson.content != null ? 'green' : '' " class="ml-2">
                                                                        mdi-check-circle-outline
                                                                    </v-icon>
                                                                    <iconButton
                                                                        class="mx-2"
                                                                        :props="{
                                                                            hasTooltip:true,
                                                                            tooltip: 'Borrar leccion',
                                                                            color:'',
                                                                            icon:'mdi-delete-outline',
                                                                            height:'35',
                                                                            iconColor: 'black',
                                                                            outline: true,
                                                                            click: () => {deleteLesson(section, indexL)}
                                                                        }"
                                                                    ></iconButton>
                                                                    <iconButton
                                                                        :props="{
                                                                            hasTooltip:true,
                                                                            tooltip: 'Contenido de la lección',
                                                                            color:'',
                                                                            icon:'mdi-pencil-outline',
                                                                            height:'35',
                                                                            iconColor: 'black',
                                                                            outline: true,
                                                                            disabled: lesson.id ? false:true,
                                                                            click: () => {
                                                                                openRich(lesson, indexS, indexL); 
                                                                                delete serverErrors[`sections.${indexS}.lessons.${indexL}.content`];
                                                                                delete serverErrors[`sections.${indexS}.lessons.${indexL}.content_type`];
                                                                                delete serverErrors[`sections.${indexS}.lessons.${indexL}.type`];
                                                                                delete serverErrors[`sections.${indexS}.lessons.${indexL}.section_id`];
                                                                                delete serverErrors[`sections.${indexS}.lessons.${indexL}`];
                                                                            }
                                                                        }"
                                                                    ></iconButton>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons.${indexL}.title`] }}</p>
                                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons.${indexL}.content`] }}</p>
                                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons.${indexL}.content_type`] }}</p>
                                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons.${indexL}.type`] }}</p>
                                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons.${indexL}.section_id`] }}</p>
                                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons.${indexL}`] }}</p>
                                                        <p class="red--text caption">{{ serverErrors[`sections.${indexS}.lessons.${indexL}`] }}</p>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            
                                        </v-row>

                                        
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>

                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>

        <!-- content form -->
        <div v-if="showRich && selectedLesson != null">
            <v-row justify="center" >
                <v-col class="text-left">
                    <div class="font-weight-bold body-1">
                        Editar lección {{ this.selectedLesson.title??'' }}
                    </div>
                </v-col>


                
            </v-row>

            <v-row>
                <v-col>
                    <v-card>
                        <v-card-text>
                         

                            <v-row>
                                <v-col>
                                    <RichTextForm
                                    :valueInput="selectedLesson.content"
                                    :images_data="values.images_data"
                                    @valueChange="
                                        (v) => {
                                            selectedLesson.content = v;
                                            delete serverErrors[`lesson.title`];
                                        }
                                    "
                                    @imagesDataChanged="
                                        (v) => {
                                            this.values.images_data.push(v);
                                            delete serverErrors[`lesson.title`];
                                        }
                                    "
                                    ></RichTextForm>
                                </v-col>
                            </v-row>


                            
                        </v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>
        </div>
       
    </div>
</template>
<script>
import separator from '../../../components/Separator.vue';
import RichTextForm from '../../../components/RichTextForm.vue';
/* eslint-disable */
export default {
    props: ["values", "stepIn", "stepClasses", "serverErrors", ],
    components: {
        separator,
        RichTextForm,
    },
    model: {
        event: "tabChanged",
    },
    watch: {
       
    },
    computed: {
        tab: {
            get: function () {
                return this.stepIn;
            },
            set: function (value) {
                //console.log(value)
                this.setRules(value);
                this.$emit("tabChanged", value);
                //this.tab = stepIn;
            },
        },

        stClasses: {
            get: function () {
                return this.stepClasses;
            },
            set: function (value) {
                //console.log(value)
                //  this.$emit('tabChanged', value)
                //this.tab = stepIn;
            },
        },

    },
    data() {
        return {
            id: this.$route.params.id,
            e1: 1,
            //tab: '',
            show4: false,
            loadingCompanies: false,
            loadingSection: false,
            selectedLesson:null,
            indexSectionSelected:null,
            indexLessonSelected:null,
            showRich:false,
            lessonBackup:null,

            // rules: {},
            addLessonBtnData: {
                text: "Agregar Lección",
                icon: "",
                to: "",	
                block:false,
                click: () => {}
            },

            rules: {
                
                required: [
                    (v) => {
                        if (v == null || v == undefined)
                            return "Campo requerido";
                        try {
                            if (typeof v === "string") {
                                if (v?.trim() == "") return "Campo requerido";
                            }
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    },
                ],

                fileRequired: [
                    v => {
                        if(this.values.image_file.length == 0 && this.values.image_url == "")
                            return "El campo es requerido"
                        return true
                    }
                ],

                listRequired: [
                    v => {
                        if(v.length == 0)
                            return "El campo es requerido"
                        return true
                    }
                ]
                
            },

          
          
            serverItems: {
               
                companies: [],
            
            },
           
        };
    },
    mounted() {
        this.getCompanies();
    },
    methods: {

        openRich(lesson, indexSection, indexLession){
            this.loadingCompanies = true;
            this.$api.course
                .getLesson(lesson.id)
                .then((resp) => {
                    let bodyWithId = JSON.parse(JSON.stringify(lesson));
                    if(resp.data['content'] != null)
                    {
                        resp.data['content'] = {
                            'type': "doc",
                            'content': resp.data['content']
                        }

                        
                        let bodyWithUrl = JSON.parse(JSON.stringify(resp.data));

                        for (let i = 0; i < bodyWithId.content.content.length; i++) {
                            const item = bodyWithId.content.content[i];
                            if(item.content != undefined && Array.isArray(item.content)){
                                for (let j = 0; j < item?.content?.length; j++) {
                                    const element = item?.content[j];
                                    if(element.type == 'image'){
                                        const id = element.attrs.src;
                                        const url = bodyWithUrl.content.content[i].content[j].attrs.src;
                                        this.values.images_data.push({id:id, url: url});
                                    }
                                }
                            }
                            
                        }
                    }
                    

                    console.log(this.values.images_data, "images_data");

                    
                    // resp.data['content']['type'] = "doc";
                    // resp.data['content']['content'] = resp.data['content'];
                    this.values.sections[indexSection].lessons[indexLession] = resp.data;
                    lesson = this.values.sections[indexSection].lessons[indexLession];
                    this.showRich = true;
                    this.indexSectionSelected = indexSection;
                    this.indexLessonSelected = indexLession;
                    this.selectedLesson = lesson;
                    this.lessonBackup = resp.data['content'] == null ? lesson : bodyWithId; //JSON.parse(JSON.stringify(lesson));
                    this.lessonBackup['type'] = this.lessonBackup.content_type;

                    console.log(this.selectedLesson)

                    this.$emit('showRichChanged', {showRich: this.showRich, idLesson: lesson.id, indexSectionSelected: this.indexSectionSelected, indexLessonSelected: this.indexLessonSelected});
                })
                .catch((error) => {
                    console.log(error, "error desde form employees");
                })
                .finally(() => {
                    this.loadingCompanies = false;
                })
            ;



           

        },

        addSection(){
            this.values.sections.push({
                title: '',
                lessons: [
                    {
                        title:'',
                        type: 'LECCIÓN'
                    }
                ]
            });
        },

        deleteLesson(section, index){
            const id = section.lessons[index]?.id??undefined;
            this.values.lessons_to_delete.push(id);
            section.lessons.splice(index, 1); 
        },
        deleteSection(index){
            const id = this.values.sections[index]?.id??undefined;
            this.values.sections_to_delete.push(id);
            this.values.sections.splice(index, 1);
        },
       

        /**
         * Set form rules by step
         */
        setRules(step) {
            // this.rules = {};
           
            // this.rules = {
            //     ...this.rulesOne,
            // };
        },

      

        /**
            Get companies from api
        */
        getCompanies() {
            this.loadingCompanies = true;
            this.$api.user
                .getUserBusinessSelect()
                .then((resp) => {
                    this.serverItems.companies = resp.data.map((item) => {
                        return { text: item.name, value: item.id };
                    });
                })
                .catch((error) => {
                    console.log(error, "error desde form employees");
                })
                .finally(() => {
                    this.loadingCompanies = false;
                });
        },

        addLesson(section, index){
            console.log(section);
            section.lessons.push({
                title: '', type: 'LECCIÓN'
            });
        },

        closeRichChild(restore = true){
            if(restore)
                this.values.sections[this.indexSectionSelected].lessons[this.indexLessonSelected] = this.lessonBackup;
            this.showRich = false;

        },



        storeSection(data) {
            this.loadingSection = true;

            this.$api.course
                .storeSection(this.id, )
                .then((resp) => {
                    this.serverItems.companies = resp.data.map((item) => {
                        return { text: item.name, value: item.id };
                    });
                })
                .catch((error) => {
                    console.log(error, "error desde form employees");
                })
                .finally(() => {
                    this.loadingSection = false;
                })
            ;
        },

       
    },
};
</script>

<style lang="scss">


.courses-form{
    &-new-section-container{
        display: flex;
        justify-content: space-between;
    }


    &-lesson-btns-container{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
}
.custom-separator-color{
    p {
        color: var(--v-normalText-lighten7) !important;
    }
}
.tab {
    &-header {
        font-size: 12px !important;
        color: var(--v-normalText-lighten4) !important;
    }

    &-active {
        color: var(--v-normalText-base) !important;
    }

    &-error {
        color: var(--v-warning-base) !important;
    }


}

</style>